// Watchlist Modals
export const WATCHLIST_ACTIONS = 'WATCHLIST_ACTIONS';
export const WATCHLIST_DELETE = 'WATCHLIST_DELETE';
export const WATCHLIST_RENAME = 'WATCHLIST_RENAME';
export const WATCHLIST_SELECTION = 'WATCHLIST_SELECTION';

// Watchlist Actions
export const ADD_WATCHLIST_FUND = 'ADD_WATCHLIST_FUND';
export const ADD_SELECTED_WATCHLIST_FUNDS = 'ADD_SELECTED_WATCHLIST_FUNDS';
export const CREATE_NEW_WATCHLIST = 'CREATE_NEW_WATCHLIST';
export const DELETE_WATCHLIST = 'DELETE_WATCHLIST';
export const REMOVE_WATCHLIST_FUND = 'REMOVE_WATCHLIST_FUND';
export const REMOVE_SELECTED_WATCHLIST_FUNDS =
    'REMOVE_SELECTED_WATCHLIST_FUNDS';
export const RENAME_WATCHLIST = 'RENAME_WATCHLIST';
export const SELECT_WATCHLIST = 'SELECT_WATCHLIST';
export const SET_FETCHED_WATCHLIST = 'SET_FETCHED_WATCHLIST';
export const SET_LOCAL_STORAGE_WATCHLIST = 'SET_LOCAL_STORAGE_WATCHLIST';
export const UPDATE_AFTER_POST = 'UPDATE_AFTER_POST';

// Watchlist Disclaimers
export const RETAIL = 'RETAIL';
export const GOVERNMENT = 'GOVERNMENT';
